import type { NewLandingPageActionPayload } from 'commons/types';
import { getNewLandingPageTypes } from './types';

export const newLandingPageActions = {
  getNewLandingPageRequest: (payload: NewLandingPageActionPayload) => ({
    type: getNewLandingPageTypes.REQUEST,
    payload,
  }),
  getNewLandingPageSuccess: (payload: any) => ({
    type: getNewLandingPageTypes.SUCCESS,
    payload,
  }),
  getNewLandingPageFailed: (payload: string) => ({
    type: getNewLandingPageTypes.FAILED,
    payload,
  }),
};
